import Cookies from 'js-cookie';
import * as URX_FORM from '../constants/urx-form';
/**
 * hook to set cookie value for top match and answer
 *
 * @returns {Object} cookie value
 */
export const useSetCookie = (
  match: string | undefined,
  ans: string[],
  cookieURL: string,
) => {
  Cookies.set(
    'urxdcq',
    JSON.stringify({
      source: URX_FORM.FORM_ID,
      dcq: {
        Q_NOTESDATA: `${cookieURL} Plan: ${match} | ${ans.join(
          ', ',
        )} | Question details: http://ibm.biz/maas360_questions`,
      },
    }),
  );
};
